import store from 'store'
import expirePlugin from 'store/plugins/expire'

store.addPlugin(expirePlugin)
store.removeExpiredKeys()

const IN_FIFTY_YEARS = new Date(new Date().setFullYear(new Date().getFullYear() + 50)).getTime()

export const storage = {
  get: (key: string) => store.get(key),
  set: (key: string, val: unknown, expire: number = IN_FIFTY_YEARS) => store.set(key, val, expire),
  remove: (key: string) => store.remove(key),
  removeExpiredKeys: () => store.removeExpiredKeys(),
  each: (fn: (key: string, value: unknown) => void) => store.each(fn),
}
